import './Botao.css'

export const Botao = ({texto}) => {
    return <button className="botao">
        {texto}
    </button>
}